module.exports = __webpack_public_path__ + "static/media/export-arrow.35d5b87c.svg";